/* Utilidades de locales en URL (Fase 13 — WS3).
 * Decisión de arquitectura: EN vive en la raíz; es/de/fr/it llevan prefijo de
 * ruta SOLO en las páginas de nivel 1 (corporativas, resources, legal). Las
 * páginas programáticas de nivel 2 (organizer/auction/lot/horse) tienen UNA
 * única URL canónica sin prefijo — su contenido es del organizador y
 * prefijarlas multiplicaría duplicados sin valor de búsqueda. */
import { useTranslation } from "react-i18next";

export const DEFAULT_LOCALE = "en";
export const PATH_LOCALES = ["es", "de", "fr", "it"];
export const ALL_LOCALES = [DEFAULT_LOCALE, ...PATH_LOCALES];

/** "/es/pricing" -> { locale: "es", path: "/pricing" }; "/pricing" -> { locale: "en", path: "/pricing" } */
export function splitLocale(pathname) {
  const seg = (pathname || "/").split("/")[1];
  if (PATH_LOCALES.includes(seg)) {
    const rest = pathname.slice(seg.length + 1) || "/";
    return { locale: seg, path: rest.startsWith("/") ? rest : `/${rest}` };
  }
  return { locale: DEFAULT_LOCALE, path: pathname || "/" };
}

/** Ruta equivalente en otro idioma: localizePath("/pricing", "de") -> "/de/pricing" */
export function localizePath(path, locale) {
  const clean = path === "/" ? "" : path;
  if (!locale || locale === DEFAULT_LOCALE) return path || "/";
  return `/${locale}${clean}` || `/${locale}`;
}

/** Hook: lp("/pricing") devuelve la ruta en el idioma activo (para nav/CTAs de nivel 1). */
export function useLocalePath() {
  const { i18n } = useTranslation();
  const lng = (i18n.resolvedLanguage || DEFAULT_LOCALE).slice(0, 2);
  return (path) => localizePath(path, ALL_LOCALES.includes(lng) ? lng : DEFAULT_LOCALE);
}
